import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import logo from "../../assets/images/admin-login-logo.png";
import api from "../../services/api";
import "./ProtectedRoute.css";

const ProtectedRoute = () => {
  const [isValidating, setIsValidating] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const verifySession = async () => {
      try {
        await api.get("/auth/verify");
        setIsAuthenticated(true);
      } catch {
        setIsAuthenticated(false);
      } finally {
        setIsValidating(false);
      }
    };

    verifySession();
  }, []);

  if (isValidating) {
    return (
      <div
        className="protected-route-loading"
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        <aside className="protected-route-loading__sidebar">
          <img src={logo} alt="7 Geracoes" />
        </aside>
        <main className="protected-route-loading__content">
          <span className="protected-route-loading__spinner" aria-hidden="true" />
          <p>Carregando painel...</p>
        </main>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;